import adminRoutes from './admin'
import mainRoutes from './main'
import marketMathRoutes from './marketmath'
import reportRoutes from './report'
import studeoRoutes from './studeo'
import systemRoutes from './system'
import websiteRoutes from './website'

export default [
	...adminRoutes,
	...mainRoutes,
	...marketMathRoutes,
	...reportRoutes,
	...systemRoutes,
	...studeoRoutes,
	...websiteRoutes,
]
